import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll altijd naar boven bij een pathname-wijziging.
 * Gebruikt `requestAnimationFrame` om te wachten tot de nieuwe route
 * gerenderd is, en zet tijdelijk `scroll-behavior: auto` op <html> zodat
 * de globale `scroll-behavior: smooth` uit index.css deze reset niet overrulet.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    // Twee frames afwachten (route swap + hydratie), dan hard resetten.
    const raf1 = requestAnimationFrame(() => {
      const raf2 = requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        html.style.scrollBehavior = prev;
      });
      return () => cancelAnimationFrame(raf2);
    });
    return () => {
      cancelAnimationFrame(raf1);
      html.style.scrollBehavior = prev;
    };
  }, [pathname]);
  return null;
};

export default ScrollToTop;

